export enum FirestoreCollection {
  Accounts = 'accounts',
  Addresses = 'addresses',
  BaseModels = 'base_models',
  Configurators = 'models',
  ConfiguratorModels = 'models',
  DescriptionOverride = 'items_have_description_override',
  Items = 'items',
  ItemsPriceUpdateLog = 'items_price_update_log',
  ItemsLegacy = 'items_legacy',
  Log = 'log',
  PartNoCrossRefs = 'part_no_cross_refs',
  PriceBrackets = 'settings/pricing/pricing_brackets',
  PriceChangesUpdateConfigurations = 'price_changes_update_configurations',
  Quotes = 'quotes',
  QuotesFollowUp = 'quotes_follow_up',
  QuotesFollowUpLogs = 'quotes_follow_up_logs',
  QuoteSummary = 'quote_summaries',
  QuoteSummaries = 'quote_summaries',
  Resources = 'resources',
  SharedAccess = 'shared_access',
  Surcharges = 'surcharges',
  Users = 'users'
}
